// extracted by mini-css-extract-plugin
export default {"cellWithImg":"Sidebar_cellWithImg__uaP1q","cellImg":"Sidebar_cellImg__Wb04-"};